import React from 'react';
import { Box, Icons, Stack, Typography } from '@curves/ui-base';
import { Overview } from '@curves/ui-shared';

import { parseDate } from '@Util/moment.util';

const headerRow = [
    {
        cellKey: 'orderDate',
        headerLabel: '建立日期',
        align: 'left',
        width: 18,
        style: { minWidth: 50, maxWidth: '18rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        formatCell: (value, { orderNo }) => {
            return (
                <Stack direction="column">
                    <Typography component="span">{parseDate(value, 'YYYY/MM/DD HH:MM')}</Typography>
                    <Typography component="span">{orderNo}</Typography>
                </Stack>
            );
        },
    },
    {
        cellKey: 'peopleInfo',
        headerLabel: '兌換人',
        align: 'center',
        width: 18,
        style: { minWidth: 50, maxWidth: '18rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        formatCell: (value, { displayName, memberNo }) => {
            return (
                <Stack direction="column">
                    <Typography component="span">{displayName}</Typography>
                    <Typography component="span">{memberNo}</Typography>
                </Stack>
            );
        },
    },
    {
        cellKey: 'redeemItemName',
        headerLabel: '贈品名',
        align: 'center',
        style: { minWidth: 50 },
        formatCell: (value) => {
            return <Typography component="span">{value}</Typography>;
        },
    },
    {
        cellKey: 'quantity',
        headerLabel: '兌換數量',
        width: 10,
        style: { minWidth: 50, maxWidth: '10rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        align: 'center',
        formatCell: (value) => {
            return <Typography component="span">{value}</Typography>;
        },
    },
    {
        cellKey: 'redeemStatus',
        headerLabel: '已簽收',
        width: 10,
        style: { minWidth: 50, maxWidth: '10rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        align: 'center',
        formatCell: (value) => {
            return String(value) === '1' ? <Icons.Check color="success" /> : null;
        },
    },
];
const PointProductGiftItemExchangeRecordTable = React.forwardRef((props, ref) => {
    const { pageSize = 10, pageIndex = 1, totalCount = 0, totalPage = 0, rowsData = [], onPageChange: onPageChangeProps } = props;
    const handlePageChange = (num) => {
        if (document.activeElement) document.activeElement.blur();
        onPageChangeProps(num);
    };
    const currentPageLastIndex = totalCount > 0 ? Math.min(pageSize * pageIndex, totalCount) : 0;
    // 組出 Overview 所需的資料與換頁函式
    const contextValue = {
        overviewData: {
            list: rowsData,
            pagination: { pageIndex, pageSize, totalCount, totalPage: totalPage ?? 0 },
        },
        updateOverviewPage: handlePageChange,
    };
    return (
        <Box className="mt-4">
            <Overview contextValue={contextValue}>
                <Stack className="overview__toolbar" alignItems="center" justifyContent="end">
                    <Typography variant="body2">{`${currentPageLastIndex > 0 ? `${currentPageLastIndex}筆` : ''}(共${totalCount}筆)`}</Typography>
                </Stack>
                <Overview.Table headerRow={headerRow} cardProps={{ className: 'theme-gray' }} />
                <Overview.Pagination className="mt-4" />
            </Overview>
        </Box>
    );
});
export default PointProductGiftItemExchangeRecordTable;
